import { render, staticRenderFns } from "./CarDealerAssignments.vue?vue&type=template&id=829a7a84"
import script from "./CarDealerAssignments.vue?vue&type=script&lang=js"
export * from "./CarDealerAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports